module.exports = __webpack_public_path__ + "media/images/pic/bialoleka/team/teachers/rodrigo-e28ef9ec0f79d1750bd3df804ecca069.webp";